import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModalParts.module.scss';

/* ────────────────────────────────────────────────────────────
 * ModalRow — the "label on left, control on right" pattern.
 *
 * Use for boolean / single-value controls where a full
 * ModalField (with stacked label above) would feel heavy. The
 * row's left side carries a title + optional meta hint, the
 * right side carries any control (a toggle, a select, a chip).
 *
 *   <ModalRow
 *     title="Allow variation"
 *     meta="Lets this item carry multiple sizes or price tiers."
 *     control={<AvailabilitySwitch ... />}
 *   />
 * ──────────────────────────────────────────────────────────── */

const ModalRow = ({ title, meta, control, children, className }) => (
  <div className={[styles.row, className || ''].filter(Boolean).join(' ')}>
    <div className={styles.rowLabel}>
      {title && <span className={styles.rowTitle}>{title}</span>}
      {meta && <span className={styles.rowMeta}>{meta}</span>}
      {children}
    </div>
    {control && <div className={styles.rowControl}>{control}</div>}
  </div>
);

ModalRow.propTypes = {
  title: PropTypes.node,
  meta: PropTypes.node,
  control: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalRow.defaultProps = {
  title: null,
  meta: null,
  control: null,
  children: null,
  className: '',
};

export default ModalRow;
